export default function (state = null, action) {
	switch (action.type) {

	case 'FETCH_GEO_INFO_SUCCESS':
		return action.response
	
	case 'LOGOUT':
		return {}
	
	default:
		return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/geoInfo.js